const ParticipantSignatureStatus = Object.freeze({
  Unset: 0,
  Signed: 1,
  PendingSignature: 2,
});

export const ParticipantSignatureStatusColor = Object.freeze({
  [ParticipantSignatureStatus.Signed]: 'orange-light',
  [ParticipantSignatureStatus.PendingSignature]: 'brown',
});

export default ParticipantSignatureStatus;
